import _sfc_main from "./Modal.vue2.js";
/* empty css           */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Modal = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-2ffcca66"]]);
export {
  Modal as default
};
//# sourceMappingURL=Modal.vue.js.map
